import { createFileRoute } from '@tanstack/react-router'
import MovePlanModal from '../../../../../../../../containers/plan-menu/components/move-items-modals/move-plan-modal'
import { plansMoveSearchSchema } from '../../../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/_plans/move/plan/$itemId/'
)({
  validateSearch: plansMoveSearchSchema,
  component: MovePlanModal
})
